import classNames from 'classnames';

import style from './style.module.css';

const Cell = ({ children, className }) => <div className={classNames(style.cell, className)}>{children}</div>;

export default Cell;
